const metrika = (target) => {
    if (target) {
        window.yaCounter94754465.reachGoal(target);
    }
}

export default metrika;